import { type PropsWithChildren } from 'react';

export const CountIndicator = ({ children }: PropsWithChildren) => (
  <div className="h-8 min-w-8 rounded-full bg-tiga-surface-lighter px-2 text-center leading-8">
    {children}
  </div>
);
